import React, { Component } from "react";
import { Icon, message, Tooltip, Button, Input, Row, Col } from 'antd';
import LangContext from "../contextProvider/LangContext";
import { Job, OutputType, ProcessType, User } from "../JmReact.js";
import GenericModal from "./GenericModal";
import SMSSend from "./SMSSend";

class SMSBalance extends Component<Props, State> {

    static contextType = LangContext;

    state = {
        modalSMSBalance: null,
        modalSMSSend: false
    }

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {

        return (<span>
            <Tooltip title={this.getText(20857)}>
                <Icon
                    type={'wechat'}
                    style={{ marginLeft: '40px', color: '#fff' }}
                    onClick={() => {
                        this.sendAPI("get_message_summeraized", "", ob => {
                            let data = ob.data ? ob.data.split("\r") : []
                            let balance = data[1] ? data[1].split("\f")[3] : null
                            this.setState({ modalSMSBalance: { balance } })
                        })
                    }}
                />
            </Tooltip>
            <GenericModal
                visible={this.state.modalSMSBalance != null}
                onCancel={() => { this.setState({ modalSMSBalance: null }) }}
                width={300}
                footer={[
                    <Button style={{ marginLeft: 10 }} onClick={() => { this.setState({ modalSMSBalance: null }) }}>{this.getText(20859)}</Button>,
                    <Button type="primary" disabled={!(this.state.modalSMSBalance?.balance > 0)} onClick={() => { this.setState({ modalSMSSend: true, modalSMSBalance: null }) }}>{this.getText(22620)}</Button>
                ]}
            >
                {this.state.modalSMSBalance ? <h2 dir="rtl">{this.getText(20858)}: {this.state.modalSMSBalance.balance}</h2> : ""}
            </GenericModal>

            <SMSSend {...this.props}
                visible={this.state.modalSMSSend}
                onCancel={() => { this.setState({ modalSMSSend: false }) }}
            />

        </span>)
    }

}

export default SMSBalance;